import axios from 'axios';
import { bannerCookieManager, getItem, setItem } from './utils';
import dateFns from 'date-fns';
import userService from './user';
import store from '../store/index';
import { clearLocalStorage } from './utils';
import { Message } from 'element-ui';
import Vue from 'vue';
import antiReptilian from './antiReptilian';
import router from '../router';
Vue.use(antiReptilian);

const basePath = '/api/';

/*设置请求拦截器*/
axios.interceptors.request.use(config => {
  let isIE =
    document.documentMode ||
    +(navigator.userAgent.match(/MSIE (\d+)/) && RegExp.$1);
  if (config.method === 'get' && isIE) {
    config.url += '?_=' + new Date().getTime(); //IE下get请求加参数清缓存
    // console.log(config);
  }
  return config;
});

// 添加一个响应拦截器
axios.interceptors.response.use(
  function(response) {
    const code = response.data.error_code;
    let href = window.location.href.split('/');
    let path = href[href.length - 1];
    let isInLogin = path.indexOf('login') === -1; //不在登陆页
    let needLogOut =
      isInLogin && path !== 'forgetPassword' && path !== 'welcome'; //登录、激活、忘记密码三个页面过期、禁用不跳转到登陆页
    if (code === 401 || code === 403) {
      userService.logout(code);
    } else if (code === 413) {
      Message.error('上传图片出错');
    } else if (code === 1000) {
      if (needLogOut) {
        let userInfoStr = getItem('local', 'twe_userInfo');
        let userInfo = JSON.parse(userInfoStr);
        if (userInfo && 'isDtUser' in userInfo && userInfo.isDtUser) {
          setItem('local', 'expired_logged', userInfo.token);
          setItem('session', 'expiredUserInfo', JSON.stringify(userInfo));
          let params = {
            name: 'dingTalk',
            userInfo: userInfoStr
          };
          router.push({
            path: '/loginerror',
            name: 'loginerror',
            query: params
          });
        } else {
          if (__VERSION === 'HQ') {
            Message.error('您的红圈线索账户已过期，请与管理员联系');
            router.push({
              path: '/error'
            });
          } else {
            Message.error('账户已过期');
            clearLocalStorage();
            setTimeout(function() {
              window.location.href = '/login';
            }, 1000);
          }
        }
      }
      return response;
    } else if (code === 6016 || code === 6017) {
      if (needLogOut) {
        let userInfoStr = getItem('local', 'twe_userInfo');
        let isWebLogin = false;
        try {
          isWebLogin = getItem('local', 'isWebLogin');
        } catch (error) {
          isWebLogin = false;
        }
        if (isWebLogin && isWebLogin != 'false') {
          let params = {
            name: 'dingTalk',
            expired: true,
            userInfo: userInfoStr
          };
          router.push({
            path: '/loginerror',
            name: 'loginerror',
            query: params
          });
        } else {
          if (__VERSION === 'HQ') {
            let message =
              code === 6016
                ? '您的红圈线索账户已被冻结，请与管理员联系'
                : '您的上级账户已冻结或过期，请与管理员联系';
            Message.error(message);
            router.push({
              path: '/error'
            });
          } else {
            let message =
              code === 6016 ? '该账户已被冻结' : '该账户的上级账户已失效或冻结';
            Message.error(message);
            setTimeout(function() {
              userService.logout(code);
            }, 1000);
          }
        }
      }
    } else if (code === 1045 && needLogOut) {
      Message.error('未激活，不能进行操作');
      clearLocalStorage();
      setTimeout(function() {
        window.location.href = '/login';
      }, 1000);
    } else if (code === 6126 || code === 6127) {
      if (needLogOut) {
        store._actions.getLoginAbnormalFlag[0](code);
      }
    } else if (code === 1069 || code === 1070) {
      // 判断如果账户停用的话
      if (needLogOut) {
        // store._actions.getLoginAbnormalFlag[0](code); //loginAbnormalFlag
        let message;
        if (code === 1069) {
          message = '您的账户被停用，请联系您的销售客服';
        } else {
          message = '您的账户被停用，请联系您的上级账户';
        }
        Message.error(message);
        setTimeout(function() {
          userService.logout(code);
        }, 1000);
      } else {
        let message = '';
        if (code === 1069) {
          message = '您的账户被停用，请联系您的销售客服';
        } else {
          message = '您的账户被停用，请联系您的上级账户';
        }
        Message.error(message);
      }
    } else if (code == 1090) {
      // 账号被删除
      Message.error('账号已被删除');
      if (isInLogin) {
        setTimeout(function() {
          userService.logout(code);
        }, 1000);
      }
    }
    return response;
  },
  function(err) {
    if (err.response) {
      let properties = {};
      let timeValue = new Date().getTime();
      let time = dateFns.format(timeValue, 'YYYY-MM-DD HH:mm:ss');
      let userInfoStr = getItem('local', 'twe_userInfo');
      let userInfo = JSON.parse(userInfoStr);
      let userId = userInfo && userInfo.userid ? userInfo.userid : '';
      let headers = err.response.headers;
      if (err.response.status == 579) {
        properties.is_first_time_show_anti_reptilian =
          headers.isfirstgeetest === 'true';
        properties.show_anti_reptilian_time = time;
        window.sa.track('show_anti_reptilian', properties);
        Vue.$antirept(err.response.data);
      } else if (err.response.status == 559) {
        if (headers.isfirsttempblack === 'true') {
          properties.user_id = userId;
          properties.add_tmp_blacklist_reason = headers.rejectcode
            ? parseInt(headers.rejectcode)
            : 0;
          properties.add_tmp_blacklist_time = time;
          console.log('add_tmp_blacklist', properties);
          window.sa.track('add_tmp_blacklist', properties);
        }
        Message.error(
          '注意！您的账户被检测到以不当方式影响正常服务，今日将被限制操作。'
        );
      } else if (err.response.status == 569) {
        if (headers.isfirstblack === 'true') {
          properties.user_id = userId;
          properties.add_blacklist_time = time;
          window.sa.track('add_blacklist', properties);
        }
        Message.error(
          '注意！您的账户被检测到以不当方式影响正常服务，已被永久限制操作。如有疑问，请联系您的客服支持。'
        );
      }
    }
  }
);
export const apiData = (method, path, params, t, hasSuccessMsg) => {
  let saParam = bannerCookieManager.getItem('sensorsdata2015jssdkcross');
  let distinct_id = '';
  if (saParam) {
    saParam = JSON.parse(decodeURIComponent(saParam));
    distinct_id = saParam.distinct_id;
  }
  let token = '';
  if (t) {
    token = t;
  } else {
    let userStr = getItem('local', 'twe_logged');
    let expiredUserStr = getItem('local', 'expired_logged');
    if (userStr) {
      token = userStr;
    } else if (expiredUserStr) {
      token = expiredUserStr; //钉钉版本过期用户
    }
  }
  let promise = new Promise((resolve, reject) => {
    axios({
      url: basePath + path,
      method: method,
      data: method == 'post' || method == 'put' ? params : '',
      params: method == 'get' && params ? params : '',
      timeout: 120000,
      headers: {
        Authorization: token,
        distinct_id: distinct_id
      },
      validateStatus: function(status) {
        return status < 500; // default
      }
    })
      .then(result => {
        if (result.data.error_code === 0) {
          if (hasSuccessMsg) {
            resolve(result.data);
          } else {
            resolve(result.data.data);
          }
        } else {
          reject(result.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  });
  return promise;
};

/*获取创建呼叫计划下拉列表接口*/
export const getRobotData = (method, path, params) => {
  let saParam = bannerCookieManager.getItem('sensorsdata2015jssdkcross');
  let distinct_id = '';
  if (saParam) {
    saParam = JSON.parse(decodeURIComponent(saParam));
    distinct_id = saParam.distinct_id;
  }
  let token = '';
  let userStr = getItem('local', 'twe_logged');
  let expiredUserStr = getItem('local', 'expired_logged');
  if (userStr) {
    token = userStr;
  } else if (expiredUserStr) {
    token = expiredUserStr; //钉钉版本过期用户
  }
  let promise = new Promise((resolve, reject) => {
    axios({
      url: path,
      method: method,
      data: method == 'post' ? params : '',
      params: method == 'get' && params ? params : '',
      timeout: 120000,
      headers: {
        Authorization: token,
        distinct_id: distinct_id
      },
      validateStatus: function(status) {
        return status < 500;
      }
    })
      .then(result => {
        if (result.data.success) {
          resolve(result.data.data);
        } else {
          reject(result.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
  return promise;
};

/*获取BMS新闻详情接口*/
export const getNewsData = (method, path, params) => {
  let promise = new Promise((resolve, reject) => {
    axios({
      url: path,
      method: method,
      data: method == 'post' ? params : '',
      params: method == 'get' && params ? params : '',
      timeout: 120000,
      headers: {
        Authorization: 'Token token=af9c059413e6e982929df5017240c76d889c9c34'
        // source: 'skb',
      },
      validateStatus: function(status) {
        return status < 500;
      }
    })
      .then(result => {
        if (result.data.code === 200) {
          resolve(result.data.data);
        } else {
          reject(result.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
  return promise;
};



// WEBPACK FOOTER //
// ./src/common/dataService.js